module.exports = __webpack_public_path__ + "lg-5fd4c338c1a1b1eeeb2c7b0a0967773d.woff";


//////////////////
// WEBPACK FOOTER
// ./~/lightgallery/dist/fonts/lg.woff
// module id = 916
// module chunks = 124